import { pollPlugin } from '../../plugins/poller'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(pollPlugin)
